<div class="container-fluid">
  <div class="form-step three-stup">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div> -->
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pagar</span>
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Certificado</span>
      </div> -->
    </div>

  </div>
  <span class="letter-style-normal adjust-text-right font-weight-bolder text-center d-block pt-3">En solo tres pasos
    podrás cotizar tu seguro. ¡Empecemos!</span>
  <div class="form-section">
    <div class="form-left-section form-itams">
      <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
    </div>
    <form [formGroup]="stepThreeForm" novalidate class="p-5 pt-4 pb-4 form-general-style mobile-form-padding">
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <app-input-field [formGroup]="stepThreeForm" controlName="applicantName" id="firstName" label="Nombres"
            [submitted]="submitted" errorMessage="Nombres requerido"></app-input-field>
          <!-- <div class="form-group">

            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantName"
              id="firstName" onclick="this.setAttribute('value', this.value);" value="">
            <label for="firstName" class="form-input-label">Nombres *</label>
            <div class="text-danger" *ngIf="submitted && stepThreeForm.controls['applicantName'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Nombres requerido
              </label>
            </div>
          </div> -->

        </div>
        <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">

          <app-input-field [formGroup]="stepThreeForm" controlName="applicantLastName" id="lastName" label="Apellidos"
            [submitted]="submitted" errorMessage="Apellidos requerido"></app-input-field>
          <!-- <div class="form-group">

            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantLastName"
              id="lastName" onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Apellidos *</label>
            <div class="text-danger" *ngIf="submitted && stepThreeForm.controls['applicantLastName'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Apellidos requerido
              </label>
            </div>
          </div> -->
        </div>
      </div>
      <div class="web-none row formControlRow mb-16px">
        <div class="col-12 m-order-1">
          <app-input-field [formGroup]="stepThreeForm" controlName="applicantEmail" id="email" label="Correo Electrónico"
            [submitted]="submitted" errorMessage="Correo Electrónico requerido"></app-input-field>

          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantEmail"
              id="email" onclick="this.setAttribute('value', this.value);" value="">
            <label for="email" class="form-input-label">Correo Electrónico*</label>
            <div class="text-danger" *ngIf="submitted && stepThreeForm.controls['applicantEmail'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Correo Electrónico requerido
              </label>
            </div>
          </div> -->
        </div>
      </div>
      <div class="row formControlRow phone-number-row mb-16px">

        <div class="formControlContainer col-md-6 col-5 m-order-2">
          
            <app-dropdown searchPlaceholder="Buscar país o código…" [options]="countries" formControlName="phoneCode" label="Código País"
              icon="/assets/external/localization-vector.svg">
              <ng-template #optionTemplate let-item>
                <div class="d-flex align-items-center">
                  <img *ngIf="item?.flag" [src]="item.flag" class="flag-icon mr-2" width="20" alt="{{ item?.name }}">
                  <span>{{ item?.code }} {{ item?.phoneCode ? ' (' + item?.phoneCode + ')' : '' }}</span>
                </div>
              </ng-template>
            </app-dropdown>
            <!-- <p-dropdown [options]="countries" optionLabel="name" optionValue="phoneCode" [filter]="true"
                [filterBy]="'name,phoneCode'" formControlName="phoneCode" id="phoneCodeId" class="p-dropdown form-input"  onclick="this.setAttribute('value', this.value);" value="">
                <ng-template pTemplate="selectedItem" let-item>
                  <div class="d-flex align-items-center">
                    <img *ngIf="item?.flag" [src]="item.flag" class="flag-icon mr-2" width="20" alt="{{ item.name }}">
                    <span>{{ item.phoneCode }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="item" let-item>
                  <div class="d-flex align-items-center">
                    <img *ngIf="item?.flag" [src]="item.flag" class="flag-icon mr-2" width="20" alt="{{ item.name }}">
                    <span>{{ item.phoneCode }}</span>
                  </div>
                </ng-template>
              </p-dropdown>
              <label for="phoneCodeId" class="form-input-label">Código</label>  -->
          
        </div>
        <div class="formControlContainer col-md-6 col-7 m-order-3">
          <app-input-field [formGroup]="stepThreeForm" controlName="applicantPhone" id="phoneNumber" label="Telefono"
            [submitted]="submitted" errorMessage="Apellidos requerido"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantPhone"
              id="phoneNumber" onclick="this.setAttribute('value', this.value);" value="">
            <label for="phoneNumber" class="form-input-label">Telefono de contacto</label>
          </div> -->
        </div>
      </div>
      <div class="mobile-none row formControlRow mb-16px">
        <div class="col-12 m-order-1">
          <app-input-field [formGroup]="stepThreeForm" controlName="applicantEmail" id="email" label="Correo Electrónico"
            [submitted]="submitted" errorMessage="Correo Electrónico requerido"></app-input-field>

          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantEmail"
              id="email" onclick="this.setAttribute('value', this.value);" value="">
            <label for="email" class="form-input-label">Correo Electrónico*</label>
            <div class="text-danger" *ngIf="submitted && stepThreeForm.controls['applicantEmail'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Correo Electrónico requerido
              </label>
            </div>
          </div> -->
        </div>
      </div>
      <div class="form-group mb-16px">
        <div class="px-4 background-effect">
          <div class="d-flex" style="justify-content: space-between; align-items: center;">
            <span style="font-size: 11px;">Estoy de acuerdo en recibir materiales promocionales y de marketing.</span>
            <p-inputSwitch formControlName="checkedMarketing" />
          </div>
        </div>
      </div>
      <div class="form-group mb-0"><button type="submit" (click)="nextStep()" [disabled]="isloading" 
          class="btn btn-primary continue-btn-steps py-3">{{isloading ? 'Cargando...' : 'Continuar'}}</button></div>

    </form>
    
    <div class="form-right-section form-itams">
      <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
    </div>
    <a href="javascript:void(0)" class="back-link" (click)="prevStep()">
      < Atrás</a>
      <div class="copy-right">
        <p>All rights reserved by BAC Financial Services. | Política de privacidad | Design by <a href="https://www.wemarkforyou.com" target="_blank">www.wemarkforyou.com</a>. </p>
        <h5>Politica de privacidad</h5>
      </div>
  </div>
  <div class="modal fade" id="quoteLoadingModal" tabindex="-1" aria-labelledby="quoteLoadingModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered send-quote-modal">
    <div class="modal-content">
      <div class="modal-body">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar">
            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none" aria-hidden="true"><path d="M14.5 16.1917L8.57917 22.1125C8.35764 22.334 8.07569 22.4448 7.73333 22.4448C7.39097 22.4448 7.10903 22.334 6.8875 22.1125C6.66597 21.891 6.55521 21.609 6.55521 21.2667C6.55521 20.9243 6.66597 20.6424 6.8875 20.4208L12.8083 14.5L6.8875 8.57917C6.66597 8.35764 6.55521 8.07569 6.55521 7.73333C6.55521 7.39097 6.66597 7.10903 6.8875 6.8875C7.10903 6.66597 7.39097 6.55521 7.73333 6.55521C8.07569 6.55521 8.35764 6.66597 8.57917 6.8875L14.5 12.8083L20.4208 6.8875C20.6424 6.66597 20.9243 6.55521 21.2667 6.55521C21.609 6.55521 21.891 6.66597 22.1125 6.8875C22.334 7.10903 22.4448 7.39097 22.4448 7.73333C22.4448 8.07569 22.334 8.35764 22.1125 8.57917L16.1917 14.5L22.1125 20.4208C22.334 20.6424 22.4448 20.9243 22.4448 21.2667C22.4448 21.609 22.334 21.891 22.1125 22.1125C21.891 22.334 21.609 22.4448 21.2667 22.4448C20.9243 22.4448 20.6424 22.334 20.4208 22.1125L14.5 16.1917Z" fill="#2828E0"/></svg>
          </button>
          <div>
            <h5 class="modal-title" id="exampleModalLabel">Estamos creando tu cotización…</h5>
            <p class="no-bg">Esto puede tardar unos segundos. ¡Gracias por tu paciencia!</p>
            <img src="/assets/img/loading_logo.gif" alt="Blue Assist" class="loading-logo">
          </div>
      </div>
    </div>
  </div>
</div>
 <button type="button" id="quoteLoadingModalToggle" class="btn btn-primary quoteLoadingModal" data-bs-toggle="modal"
                data-bs-target="#quoteLoadingModal" style="display: none;">Enviar Correo</button>

<!-- Error Modal Component -->
<app-error-modal 
  [errorData]="currentErrorData" 
  (actionClick)="onErrorActionClick($event)">
</app-error-modal>
  
</div>